import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <section
        style={{ marginTop: "80px" }}
        className="py-5 d-flex items-center bg-blue-1-05"
      >
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center font-inter text-14 fw-500 text-light-1">
                <div className="col-auto">
                  <a href="/" className="cursor-pointer">
                    Home
                  </a>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div className="text-primary">Privacy Policy</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our-terms">
        <div className="container">
          <div className="">
            <div className="col-12">
              <div className="">
                <div className="grids mb20">
                  <h3 className="py-15">Privacy Policy:</h3>
                  <p className="mb15 py-10 text-justify">
                    <strong>1. Effective date:</strong>{" "}
                    <strong>August 22, 2022</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    FITIZEN INDIA LLP (“<strong>Company</strong>” or “
                    <strong>We</strong>” or “<strong>Us</strong>” and their
                    connotations) operates a website called Fitizen (url:
                    https://www.fitizen.co.in) (“<strong>Platform</strong>”)
                    which is engaged in providing the service of connecting any
                    event organisers/vendors/pacers/runners and end users who
                    wish to avail the services offered by the event
                    organisers/vendors/pacers/runners.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>2.</strong> Our Platform is primarily for the event
                    organisers/vendors/pacers/runners who are enlisted on our
                    Platform and the end users who want to avail the services
                    provided by the event organisers/vendors/pacers. The Users
                    below the age of 18 years shall be deemed to have obtained
                    parental consent to use the Platform. The event
                    organisers/vendors/pacers/runners hereinafter are referred
                    to as You. The term “<strong>User(s)</strong>” for the
                    purposes of this Privacy Policy shall be read as the event
                    organisers/vendors/pacers/runners and/or You.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>3.</strong> The Platform gathers certain information
                    with prior consent from the Users. Any capitalized term used
                    but not defined in this Privacy Policy shall have the
                    meaning attributed to it in our Terms.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>4.</strong> Our User’s privacy is extremely
                    important to us. We recognize the privacy concerns of the
                    Users and hence as a commitment to provide safe and secure
                    experience on our Platform, we have formulated this privacy
                    policy to help Users make an informed decision.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>5. LEGAL BASIS:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    This Privacy Policy (‘‘<strong>Privacy Policy</strong>’’) is
                    meant to help the Users understand what information we
                    collect, why we collect it, what information we disclose and
                    how the Users can update, manage, export, and delete their
                    information. It shall be read with the terms and conditions
                    available on [insert the link to the terms and conditions)
                    (“<strong>Terms</strong>”) and in compliance with the
                    following:
                  </p>
                  <div className="col-lg-12 ml10">
                    <div className="mt0">
                      <ul className="order_list list-style-type-bullet list-inline-item">
                        <li>The Information Technology Act, 2000</li>
                        <li>
                          The Information Technology (Reasonable Security
                          Practices and Procedures and Personal Information)
                          Rules, 2011 (the “<strong>IT Rules</strong>”)
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="mb15 py-10 text-justify">
                    The Information Technology (Intermediaries Guidelines)
                    Rules, 2011
                  </p>
                  <p className="mb15 py-10 text-justify">
                    This Privacy Policy and the Terms shall be governed by and
                    construed in accordance with the Arbitration and
                    Conciliation Act, 1996, or such similar laws of India which
                    are not in conflict with each other. Such shall be subject
                    to the exclusive jurisdiction of the competent courts of
                    Mumbai, India.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>6. CONSENT:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    The Users will be deemed to have read, understood and agreed
                    to the terms as provided in this Privacy Policy. By granting
                    their assent to this Privacy Policy, Users provide consent
                    to such use, collection and disclosure of Personal
                    Information as prescribed in this Privacy Policy.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We reserve the right to update or change our Privacy Policy
                    at any time and the Users should check this Privacy Policy
                    periodically.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    Continued use of the Service after we post any modifications
                    to the Privacy Policy on this page will constitute the
                    Users’ acknowledgment of the modifications and their consent
                    to abide and be bound by the modified Privacy Policy. Users
                    have the right to opt out of the Platform and/or Services at
                    any moment. In addition, the Users can, by sending an email
                    to fitizenindia@gmail.com, inquire whether the Company is in
                    possession of their personal data, and they may also require
                    the Company to delete and destroy all such information.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    In the event the Services are used on behalf of any other
                    individual (such as a child/parent etc.), or on behalf of
                    any entity, the Users represent that they are authorized to
                    accept this Privacy Policy and share such data as required
                    on behalf of such person or entity.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>7. INFORMATION COLLECTED:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    All information collected by the Company is with the Users’
                    consent. The Company is however free to use, collect, and
                    disclose information of the Users which is in the public
                    domain.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    When Users use/register on the Platform, the Users may
                    provide the Company with certain information voluntarily
                    specific to the nature of the service being availed on the
                    Platform and/or certain information may be collected by the
                    Company. This information may include sensitive personal
                    information as defined under the IT rules (“
                    <strong>Personal Information</strong>”).
                  </p>
                  <p className="mb15 py-10 text-justify">
                    The Users hereby consent to the collection of such
                    information by the Company.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    Information collected by the Company shall include but not
                    be limited to the following:
                  </p>
                  <div className="col-lg-12 ml10">
                    <div className="mt0">
                      <ul className="order_list list-style-type-bullet list-inline-item">
                        <li>Name;</li>
                        <li>Company details: (Name, address, GST & PAN)</li>
                        <li>
                          Contact Details (Permanent Address, Correspondence
                          Address, Email ID, Mobile No etc.);
                        </li>
                        <li>Date of Birth, Nationality;</li>
                        <li>Age, Gender and other Demographics;</li>
                        <li>
                          Financial information (like credit card, banking
                          details), if applicable.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="mb15 py-10 text-justify">
                    We also collect certain information either when the Users
                    provide it using the Platform or Services and/or
                    automatically as you navigate through the Platform (which
                    may include usage details, IP address, device ID and type,
                    your browser type and language, the operating system used by
                    your device, access times, and information collected through
                    cookies, web beacons, and other tracking technologies).
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We may also collect information associated with any other
                    account (such as your Facebook, WhatsApp, Yahoo, Google
                    accounts) that you use to sign in to or in any other manner
                    connected with the Platform. This includes, without
                    limitation, any information that you have made public
                    through such an account, information that such account
                    service-provider shares with us or information that is
                    disclosed during the sign-up and sign-in processes.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    If the Company has reasons to suspect that the information
                    provided by any User is misleading, inaccurate, obsolete, or
                    incomplete, the Company reserves the right to refuse
                    provision of the Services to the User, at its sole
                    discretion.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>8. USE OF THE INFORMATION COLLECTED:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We collect Personal Information only necessary for the
                    following purposes:
                  </p>
                  <div className="col-lg-12 ml10 mb15">
                    <div className="mt0">
                      <ul className="order_list list-style-type-bullet list-inline-item">
                        <li>To create and maintain your account;</li>
                        <li>
                          To enable you to avail of our Services, and ensure
                          efficient customer care experience and develop new
                          features;
                        </li>
                        <li>
                          To send surveys or marketing communications to inform
                          you of new products or services or other information
                          that may be of interest;
                        </li>
                        <li>
                          To improve marketing and promotional efforts, to
                          analyze Platform usage, improve the Platform’s content
                          and Service offerings, and customize the App’s
                          content, layout, and Services;
                        </li>
                        <li>
                          To dispatch transaction-related communications such as
                          welcome letters and billing reminders;
                        </li>
                        <li>
                          To notify the necessary information related to the
                          Platform and your account on the Platform from time to
                          time;
                        </li>
                        <li>
                          To maintain records and provide you with an efficient,
                          safe and customized experience while using the
                          Platform;
                        </li>
                        <li>
                          To analyze overall trends to help us improve the
                          Platform and Services;
                        </li>
                        <li>
                          To verify your identity and prevent fraud or other
                          unauthorized or illegal activity;
                        </li>
                        <li>
                          To comply with legal obligations and enforce our
                          Terms.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="mb15 py-10 text-justify">
                    <strong>9. DISCLOSURE OF INFORMATION:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We may disclose your Personal Information:
                  </p>
                  <div className="col-lg-12 ml10 mb15">
                    <div className="mt0">
                      <ul className="order_list list-style-type-bullet list-inline-item">
                        <li>
                          To our affiliates, business partners, and third-party
                          service providers who assist us in providing the
                          Services and operating our Platform;
                        </li>
                        <li>
                          In connection with any legal process, litigation, or
                          inquiry, or to comply with any legal or regulatory
                          requirements;
                        </li>
                        <li>
                          To enforce our Terms and Conditions or other
                          agreements;
                        </li>
                        <li>
                          If we are involved in a merger, acquisition, or asset
                          sale, we may transfer your information as part of that
                          transaction;
                        </li>
                        <li>
                          With your consent or as otherwise disclosed to you at
                          the time of collection.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="mb15 py-10 text-justify">
                    <strong>10. SECURITY:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We take appropriate security measures to protect your
                    Personal Information from unauthorized access, alteration,
                    disclosure, or destruction. We implement physical,
                    administrative, and technical safeguards to protect the
                    information we collect.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    However, no method of transmission over the Internet or
                    method of electronic storage is 100% secure. Therefore, we
                    cannot guarantee its absolute security.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>11. YOUR RIGHTS:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    You have the right to access, correct, update, or delete
                    your Personal Information. You may exercise these rights by
                    contacting us at fitizenindia@gmail.com.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    You may also withdraw your consent for us to use your
                    Personal Information by notifying us, but this may affect
                    your ability to use the Platform or Services.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>12. COOKIES:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We use cookies and similar tracking technologies to enhance
                    your experience on the Platform. You can control the use of
                    cookies through your browser settings.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>13. THIRD-PARTY LINKS:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    Our Platform may contain links to other websites. We are not
                    responsible for the privacy practices or the content of such
                    third-party websites.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>14. CONTACT US:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    If you have any questions or concerns about this Privacy
                    Policy, please contact us at:
                  </p>
                  <div className="col-lg-12 ml10 mb15">
                    <p className="mb15 py-10">FITIZEN INDIA LLP</p>
                    <p className="mb15 py-10">Email: fitizenindia@gmail.com</p>
                    {/* <p className="mb15 py-10">Address: [Insert Address]</p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
